import styled from 'styled-components'
import { theme, SITE_HEADER_HEIGHT, Img } from '@superhi/design'

export const HeroImage = styled(Img)`
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  object-position: center;

  @media ${theme.breakpoints.medium} {
    max-height: calc(85vh - ${SITE_HEADER_HEIGHT.medium}px);
  }

  @media ${theme.breakpoints.large} {
    max-height: calc(85vh - ${SITE_HEADER_HEIGHT.large}px);
  }
`
